import { render } from "./SecondSlide.vue?vue&type=template&id=579e6476&scoped=true"
import script from "./SecondSlide.vue?vue&type=script&lang=js"
export * from "./SecondSlide.vue?vue&type=script&lang=js"

import "./SecondSlide.vue?vue&type=style&index=0&id=579e6476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579e6476"]])

export default __exports__